import { createAction } from '@reduxjs/toolkit'

import { AudienceInsightsSource } from '@enums'
import {
  AudienceInsightsActionTypes,
  IAudienceInsights,
  IBrandConnectAudienceInsight,
} from './types'

export const fetchAudienceInsights = (
  identityId: number,
  source: AudienceInsightsSource,
  submissionId?: number,
) => ({
  type: AudienceInsightsActionTypes.FETCH_REQUEST,
  payload: { identityId, source, submissionId },
})

export const fetchAudienceInsightsSuccess = (
  identityId: number,
  audienceInsights: IAudienceInsights,
) => ({
  type: AudienceInsightsActionTypes.FETCH_SUCCESS,
  payload: { identityId, audienceInsights },
})

export const fetchBrandConnectAudienceInsightsSuccess = (
  submissionId: number,
  audienceInsights: ReadonlyArray<IBrandConnectAudienceInsight>,
) => ({
  type: AudienceInsightsActionTypes.BRAND_CONNECT_FETCH_SUCCESS,
  payload: { submissionId, audienceInsights },
})

export const fetchAudienceInsightsError = (error: any) => ({
  type: AudienceInsightsActionTypes.FETCH_ERROR,
  payload: error,
})

export const applyAudienceInsightFilters = createAction(
  AudienceInsightsActionTypes.APPLY_FILTERS,
  (filters: Record<string, string>) => ({
    payload: filters,
  }),
)
